<template>
  <div id="count-down" class="d-flex align-items-center">
    <span>残り<span v-if="screen">時間</span></span>
    <span class="td-time" :class="screen ? 'message w6' : ''">
      '{{ timeLeftString ?? '00:00:00' }}
    </span>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  props: {
    timeStart: {
      required: true,
    },
    screen: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      timeLeftString: '',
      timeLeft: 0,
      timer: null,
      timezone: ((new Date()).getTimezoneOffset() * -1) / 60,
    };
  },
  watch: {
    timeLeft() {
      if (this.timeLeft > 0) {
        let seconds = Math.floor((this.timeLeft / 1000) % 60);
        let minutes = Math.floor((this.timeLeft / (1000 * 60)) % 60);
        let hours = Math.floor((this.timeLeft / (1000 * 60 * 60)));
        hours = (hours < 10) ? `0${hours}` : hours;
        minutes = (minutes < 10) ? `0${minutes}` : minutes;
        seconds = (seconds < 10) ? `0${seconds}` : seconds;
        this.timeLeftString = `${hours}:${minutes}:${seconds}`;
      } else {
        this.timeLeftString = '';
      }
    },
  },
  mounted() {
    const now = dayjs();
    let endTime = dayjs(this.timeStart)
      .add(this.timezone, 'hour')
      .add(72, 'hour');
    if (this.screen) {
      endTime = dayjs(this.timeStart)
        .add(72, 'hour');
    }
    this.timeLeft = endTime.diff(now);
    this.timer = setInterval(() => {
      if (this.timeLeft <= 0) {
        clearInterval(this.timer);
        this.$emit('endCountDown');
      } else {
        this.timeLeft -= 1000;
      }
    }, 1000);
  },
  methods: {},
};
</script>
